<template>
  <div v-if="!hidePricing">
    <!-- Condensed Mode -->
    <div
      v-if="hasBreaks && (!expanded) && (offersSavings || offersShowSavings)"
      class="position-relative main mb-1">
      <button
        class="btn btn-sm btn-primary"
        @click="toggle"
        style="cursor: pointer; font-size:12px; padding: 0px 5px;">
        <i :class="show ? 'fa fa-caret-down' : 'fa fa-info-circle'"/>
        View Qty Breaks
      </button>
      <div
        v-if="show"
        class="qty-card animate__animated animate__fadeIn animate__faster mt-1"
        :style="breakStyle">
        <table class="table table-sm table-dark text-center text-white">
          <thead v-show="!confirm">
            <th>Price</th>
            <th>Qty</th>
          </thead>
          <!-- Virtual Show Breaks -->
          <tbody v-if="virtualShow">
            <tr
              v-for="(b,i) in vShowBreaks"
              v-show="!confirm"
              :key="i">
              <td>{{numeral(b[`qty_break${i+1}_price`]).format('$0,0.00')}}</td>
              <td>
                <a
                  href="javascript: void(0)"
                  class="text-light"
                  :title="'Add ' + b[`qty_break${i+1}`] + b[`qty_break${(i+1) + '_uom'}`] + ' to cart'"
                  @click="addQty(b, true, i+1)">
                  {{numeral(b[`qty_break${i+1}`]).format('0,0')}}
                </a>
              </td>
            </tr>
            <tr
              v-if="confirm"
              class="animate__animated animate__bounceIn animate__faster">
              <td>
                <i class="fa fa-check-circle text-sucess fa-2x"/>
                <h4>Added to cart!</h4>
              </td>
            </tr>
          </tbody>
          <!-- Qty Breaks standard and promo-->
          <tbody v-else>
            <tr
              v-for="b in breaks"
              v-show="!confirm"
              :key="b.id"
              :class="b.promo ? 'bg-success' : ''">
              <template v-if="b.visible">
                <td class="position-relative">
                  <strong>{{numeral(b.price).format('$0,0.00')}}</strong>
                  <div v-if="b.sqftPrice">
                    <small>
                      ({{ numeral(b.sqftPrice).format('$0,0.00') }} sqft)
                    </small>
                  </div>
                </td>
                <td>
                  <strong>
                    <a
                      href="javascript: void(0)"
                      class="text-light"
                      :title="`Add ${b.quantity} ${displayUom(b.uom)} to cart`"
                      @click="addQty(b)">
                      {{numeral(b.quantity).format('0,0')}}
                      {{ displayUom(b.uom) }}
                    </a>
                  </strong>
                </td>
              </template>
            </tr>
            <tr
              v-if="confirm"
              colspan="2"
              class="animate__animated animate__bounceIn animate__faster">
              <td class="text-center">
                <i class="fa fa-check-circle text-success fa-2x"/>
                <h5>Added to cart!</h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Expanded Mode -->
    <div v-if="hasBreaks && expanded && (offersSavings || offersShowSavings)">
      <div class="text-center">
        <div
          class="fw-bold w-100 bg-primary text-white"
          style="font-size:12px">
          Qty Breaks
      </div>
        <table class="table table-sm text-center bg-primary-faded">
          <thead v-show="!confirm">
            <th>Price</th>
            <th>Qty</th>
          </thead>
          <!-- Virtual Show Breaks -->
          <tbody v-if="virtualShow">
            <tr
              v-for="(b,i) in vShowBreaks"
              v-show="!confirm"
              :key="i">
              <td>{{numeral(b[`qty_break${i+1}_price`]).format('$0,0.00')}}</td>
              <td>
                <a
                  href="javascript: void(0)"
                  :title="'Add ' + b[`qty_break${i+1}`] + b[`qty_break${(i+1) + '_uom'}`] + ' to cart'"
                  @click="addQty(b, true, i+1)">
                  {{numeral(b[`qty_break${i+1}`]).format('0,0')}}
                </a>
              </td>
            </tr>
            <tr
              v-if="confirm"
              class="animate__animated animate__bounceIn animate__faster">
              <td>
                <i class="fa fa-check-circle text-sucess fa-2x"/>
                <h4>Added to cart!</h4>
              </td>
            </tr>
          </tbody>
          <!-- Qty Breaks standard and promo-->
          <tbody v-else>
            <tr
              v-for="b in breaks"
              v-show="!confirm"
              :key="b.id">
              <template v-if="b.visible">
                <td class="position-relative">
                  <strong>{{numeral(b.price).format('$0,0.00')}}</strong>
                  <div v-if="b.sqftPrice">
                    <small>
                      ({{ numeral(b.sqftPrice).format('$0,0.00') }} sqft)
                    </small>
                  </div>
                </td>
                <td>
                  <a
                    href="javascript: void(0)"
                    :title="`Add ${b.quantity} ${displayUom(b.uom)} to cart`"
                    :disabled="!cart"
                    @click="addQty(b)">
                    {{numeral(b.quantity).format('0,0')}}
                    {{ displayUom(b.uom) }}
                  </a>
                </td>
              </template>
            </tr>
            <tr
              v-if="confirm"
              colspan="2"
              class="animate__animated animate__bounceIn animate__faster">
              <td class="text-center">
                <i class="fa fa-check-circle text-success fa-2x"/>
                <h5>Added to cart!</h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import {showDetail, showQtyBreaks} from '../../../../shared/showDetail'
  import {promoProductBreaks} from '../../../../shared/promoHelpers'
  import { displayUom } from '../../../../shared/ProductFunctions'

  export default {
    props:{
      product: Object,
      view: {
        type: String,
        default: ''
      },
      virtualShow: {
        type: Boolean,
        default: false
      },
      activeUom:{
        type: Object
      },
      productPricing:{
        type: Object
      }
    },
    data(){
      return{
        show: false,
        confirm: false
      }
    },
    mounted(){
      this.$emit('hasBreaks', this.hasBreaks)
    },
    methods:{
      toggle(){
        this.show = !this.show
        this.emitStatus()
      },
      open(){
        this.show = true
        this.emitStatus()
      },
      close(){
        this.show = false
        this.emitStatus()
      },
      emitStatus(){
        this.$emit('showQtyStatus', this.show)
      },
      addQty(qtyBreak, vShow = false, breakID = null){
        if(this.cart){
          // Virtaul Show Qty Break Add
          if(vShow && breakID){
            this.product.cartData = {
              qty: parseInt(qtyBreak[`qty_break${breakID}`]),
              uom: qtyBreak[`qty_break${breakID}_uom`].uom,
              virtualShow: true
            }
          }else if(this.activeUom){
            // Standard Qty Break Add With activeUom
            this.product.cartData = {
              qty: parseInt(qtyBreak.quantity),
              uom: qtyBreak.uom,
              activeUom: this.activeUom
            }
          }else{
            // Standard Qty Break Add
            this.product.cartData = {
              qty: parseInt(qtyBreak.quantity),
              uom: qtyBreak.uom
            }
          }
          this.confirm = true
          setTimeout(function(){
            this.confirm = false
          }.bind(this), 3000)
          this.$store.dispatch('addToCart', this.product)
        }
      },
      displayUom(uom){ return displayUom(uom) }
    },
    computed:{
      cart(){return this.$store.getters.cart},
      promoProductDetail(){return this.product.promo},
      promoProductBreaks(){return promoProductBreaks(this.product)},
      hasBreaks(){
        // Virtual show qty breaks
        if(this.virtualShow && this.vShowBreaks){
          return true
        }
        if(!this.virtualShow){
          const hasPromoBreaks = !!(this.promoProductBreaks && this.promoProductDetail)
          const hasStandardBreaks = this.product.eclipse_data?.price_breaks?.length > 1
          if(hasPromoBreaks || hasStandardBreaks){
            return this.breaks.some(b => b.visible)
          }
        }
        return false
      },
      homeBranch(){return this.$store.getters.homeBranch},
      vShowBreaks(){
        if(this.virtualShow){
          const detail = showDetail(this.product)
          if(detail){
            return showQtyBreaks(detail)
          }
          return false
        }
        return false
      },
      promoBreaks(){
        const breaks = []
        if(this.promoProductDetail && this.promoProductBreaks){
          const ppd = this.promoProductDetail
          const breakLevels = [1,2,3]
          breakLevels.forEach(function(l){
            breaks.push({
              uom:  ppd[`qty_break${l}_uom`],
              price:  ppd[`qty_break${l}_price`],
              quantity:   ppd[`qty_break${l}`],
              promo: true
            })
          })
        }
        return breaks
      },
      breaks(){
        // Get breaks with base price break removed
        const exclude = ['hf']
        let breakList = _.reject(this.product.eclipse_data.price_breaks, b => exclude.includes(b.uom))

        // Set base visibility
        breakList.forEach(function(b){
          b.visible =  b.price < this.productPricing.price
        }.bind(this))

        // Handle combined standard qty breaks and promo qty breaks
        if(this.promoProductDetail || this.promoProductBreaks){
          const promoPrice = parseFloat(this.promoProductDetail.promo_price)
          const combined = _.orderBy([..._.reject(this.promoBreaks, {uom: null}), ...breakList], 'price', 'desc')

          // Set base values
          combined.forEach((qb) => {
            qb.price = parseFloat(qb.price)
            qb.quantity = parseInt(qb.quantity)
            qb.visible = qb.price < promoPrice
          })

          combined.forEach((qb) => {
            // If promo & standard share a qty, hide the higher priced one
            const likeQty = _.filter(combined, {quantity: qb.quantity})
            if(likeQty.length > 1) _.maxBy(likeQty, 'price').visible = false

            // Hide standard breaks where a promo at a lower qty already beats the price
            if(qb.promo){
              _.filter(breakList, b => b.quantity > qb.quantity).forEach((g) => {
                if(qb.price < g.price){
                  const match = _.find(combined, {price: g.price})
                  if(match) match.visible = false
                }
              })
            }
          })

          return combined
        }

        // Active Uom Converted Breaks
        if(this.activeUom){
          const uom = this.activeUom.uom
          const uomList = this.product.eclipse_data.uoms
          const uomMatch = _.find(uomList, {name: uom})
          const sqft = _.find(uomList, {name: 'sf'})
          let convertedBreaks = []
          breakList.forEach((b) => {
            b.uomQuantity = _.find(uomList, {name: b.uom}).quantity
            const price = (b.price / this.product.eclipse_data.per_qty) * uomMatch.quantity
            const converted = {
              price: price,
              quantity: uom == b.uom ? b.quantity : b.uomQuantity / (uomMatch.quantity / b.quantity),
              sqftPrice: sqft ? (b.price / this.product.eclipse_data.per_qty) * sqft.quantity : null,
              uom: uom,
              visible: price < this.activeUom.price
            }
            convertedBreaks.push(converted)
          })
          if(convertedBreaks.length) return convertedBreaks
        }

        return breakList
      },
      offersShowSavings(){
        let status = false
        if(this.virtualShow && this.vShowBreaks.length){
          const detail = showDetail(this.product)
          const bestPrice = parseFloat(_.min([this.product.eclipse_data?.unit_price, detail.show_price]))
          this.vShowBreaks.forEach(function(b, i){
            i += 1
            if(b[`qty_break${i}_price`] <= bestPrice){
              status = true
            }
          })
        }
        return status
      },
      offersSavings(){
        let status = false
        // Promo Qty Break Savings
        if(this.promoProductBreaks && this.promoProductDetail){
          const ppd = this.promoProductDetail
          status = this.promoBreaks.some(b => parseFloat(b.price) < parseFloat(ppd.promo_price))
          return status
        }
        // Standard Qty Break Savings
        if(this.product.eclipse_data?.price_breaks?.length > 1 && this.breaks.length > 0){
          const productPrice = this.activeUom ? this.activeUom.price : this.productPricing?.price
          if(productPrice){
            status = this.breaks.some(b => b.price < productPrice)
            return status
          }
        }
        return status
      },
      productView(){return this.$store.getters.productView},
      breakStyle(){
        if(this.productView == 'list'){
          return {position: 'static', width: '100%'}
        }else{
          return {position: 'absolute', width: '12rem'}
        }
      },
      hidePricing(){return this.$store.getters.hidePricing},
      expanded(){
        const user = this.$store.getters.user
        return user.qty_breaks_expanded || false
      }
    }
  }
</script>

<style scoped>
  .qty-card{
    height: auto;
    background: var(--bs-primary);
    box-shadow: 1px 1px 5px gray;
    padding: 10px;
    border-radius: 5px;
    font-size:16px;
    font-weight: 500;
    z-index: 3;
  }
  th, td{
    font-size:12px;
  }

  .promo-row{
    color: var(--bs-success);
    font-weight: bolder;
  }
  @media(max-width: 575px){
    .table{
      margin-bottom: 30px;
    }
  }
  .table-dark{
    --bs-table-bg: var(--bs-primary);
    --bs-table-color: var(--bs-light);
  }
  .bg-primary-faded{
    thead, tr > td{
      background: rgb(var(--bs-primary-rgb), 0.2)
    }
  }
</style>